export default __webpack_public_path__ + "static/home-william-f0ddc61c734800a201d250435814a4f8.png";